import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Icons, WhetherIcon, whetherIconsWithAnimations } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { WEATHER_ICON } from "../../../Data/Icons";
import { Breadcrumbs } from "../../../AbstractElements";

const WhetherIconContainer = () => {
  return (
    <>
    <Breadcrumbs pageTitle={WhetherIcon} parent={Icons} title={WhetherIcon} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={whetherIconsWithAnimations} />
              <CardBody>
                <Row className="icon-lists whether-icon">
                  {WEATHER_ICON.map((icon, i) => (
                    <Col lg="2" xs="3" key={i}>{icon.icon}</Col>
                  ))}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      </>
  );
};

export default WhetherIconContainer;
